<template>
  <div class="audit">
    <div class="audit-nav">
      <div class="income-nav-title">
        <van-cell-group>
          <van-cell center :value="currentDate" is-link>
            <template #title>
              <span>{{ params.status | orderStatus }}</span>
              <van-icon name="arrow-down" @click="showOrderPicker = true" />
            </template>
            <template #right-icon>
              <van-icon name="arrow-down" @click="showDatePicker = true" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </div>
    <List :page="page" @requestList="handleLoad">
      <OrderCell :orderList="orderList" :cellList="cellList">
        <template v-slot:region="{item}">
          <template v-if="item.customerOrg">
            <p v-for="org in item.customerOrg" :key="org.id">{{ org.orgName }}</p>
          </template>
        </template>
        <template v-slot:order-status="{item}">
          <span :style="{ color: orderStatusColor(item.status) }">{{ item.status | orderStatus }}</span>
        </template>
         <template v-slot:order-footer="{item}">
          <div class="order-footer">
            <van-button
              size="small"
              @click="$router.push({ name: 'OrderDetails', query: { id: item.id, orderNo: item.orderNo, status: 'audit' } })"
            >查看订单</van-button>
          </div>
        </template>
      </OrderCell>
    </List>
    <!-- 日期选择器 -->
    <MonthPicker
      :currentDate.sync="currentDate"
      :showDatePicker.sync="showDatePicker"
      @changeDate="params = { ...params, ...$event }"
    />
    <!-- 选择订单类型 -->
    <van-popup v-model="showOrderPicker" round position="bottom">
      <van-picker
        title="订单类型"
        value-key="name"
        show-toolbar
        :columns="ordeColumns"
        @cancel="showOrderPicker = false"
        @confirm="confirmOrderStatus"
      />
    </van-popup>
  </div>
</template>

<script>
import MonthPicker from '@/components/date/monthPicker';
import { orderList as getOrderList } from '@/api/order';
import List from '@/components/list';
import OrderCell from '@/components/order/cell';
import { getMonthStartTime, getMonthEndTime, orderStatusColor, currentMonth } from '@/utils';
import { orderContent, money } from '@/filters';
export default {
  components: { MonthPicker, List, OrderCell },
  data() {
    return {
      currentDate: currentMonth,
      showDatePicker: false,
      showOrderPicker: false,
      ordeColumns: [
        { name: '全部订单', value: undefined },
        { name: '待确认', value: 0 },
        { name: '已确认', value: 1 },
        { name: '已驳回', value: 2 }
      ],
      orderList: [],
      cellList: [
        { title: '订单金额', value: 'payed', border: true, filter: money },
        { title: '订单编号', value: 'orderNo' },
        { title: '订单内容', value: 'orderType', filter: orderContent },
        { title: '订单成交人', value: 'orderSubmitOwnerName' },
        { title: '机构', slot: 'region' },
        { title: '客户姓名', value: 'customerName' },
        { title: '订单状态', value: 'status', slot: 'order-status' }
      ],
      page: {
        currentPage: 1,
        currentCount: 10,
        totalCount: 0,
        totalPage: 0
      },
      params: {
        startTime: getMonthStartTime(currentMonth),
        endTime: getMonthEndTime(currentMonth),
        status: undefined
      }
    }
  },
  watch: {
    params: {
      handler(newVal) {
        const params = {
          ...newVal,
          page: 1,
          count: this.page.currentCount
        };
        this.getOrderList(params, true);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    confirmOrderStatus(val) {
      this.params.status = val.value;
      this.showOrderPicker = false;
    },
    orderStatusColor,
    /**
     * 滚动加载数据
     */
    handleLoad() {
      const { currentPage: page, currentCount: count } = this.page;
      this.getOrderList({ page: page + 1, count, ...this.params });
    },
    /**
     * 获取订单列表
     */
    getOrderList(params, isClean) {
      getOrderList(params).then(res => {
        if (res.errcode === 0) {
          if (isClean) {
            this.orderList = res.data;
          } else {
            this.orderList = this.orderList.concat(res.data);
          }
          this.page = res.page;
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.audit {
  &-nav { background-color: #fff;  margin-bottom: 15px;
    .van-cell__value { color: #333; }
    .van-icon-arrow-down { line-height: 24px; margin-left: 10px; color: #969799; font-size: 20px; font-weight: bold; vertical-align: top; }
  }
}
</style>